import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Logo from '../components/Logo';
import Sidebar from '../components/Sidebar'
import escapeHtml from '../functions/Validator';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchPriceList, savePriceList, signOut } from '../store/adminSlice';
import HeaderScaff from '../components/HeaderScaff';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useMediaQuery } from '@mui/material';
import IconButton from '@mui/material/IconButton';

function PriceList() {
    const isNonMobile = useMediaQuery("(min-width: 768px)");
    const [ sidebarOpen, setSidebarOpen ] = useState(true);
    const navigate = useNavigate();
    const [ needed, setNeeded ] = useState(false);
    const adminID = useSelector((state) => state.admin?._id);
    const fetchedPriceList = useSelector((state) => state.admin?.priceList || {});

    const defaultPriceList = {
        linearMerterageCost: "35.00",
        hopUpCost: "35.00",
        saddleCost: "36.00",
        throwinCost: "35.00",
        hakkiLayher: "35.00",
        temporaryRoof: "28.00",
        monoflex: "3.00",
        shrinkwrap: "6.00",
        fivebyonepointeightTower: "175.00",
        fivebyonepointeightTowerCostPerLift: "75.00",
        eightbytwopointfourTower: "200.00",
        eightbytwopointfourTowerCostPerLift: "85.00",
        tenbythreeTower: "250.00",
        tenbythreeTowerCostPerLift: "95.00",
        thirteenbyfourTower: "300.00",
        thirteenbyfourTowerCostPerLift: "100.00",
        scaffoldingInspectionPerVisit: "75.00",
        overhirePercentage: "10",
        addItem: [],
        adminID: adminID || ''
    };

    const [priceList, setPriceList] = useState(defaultPriceList);
    const [temp, setTemp] = useState({name: "", cost: ""});
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const subscribed = useSelector((state) => state.admin?.subscribed);
    const statesignOut = useSelector((state) => state.admin?.signOut);

    useEffect(() => {
        if (statesignOut === "signOut") {
            dispatch(signOut())
        }
    }, [statesignOut, dispatch]);

    useEffect(() => {
      if(!adminID){
        navigate("/signin")
      } else if (!subscribed) {
        navigate("/signin")
      }
      if(!isNonMobile){
        setSidebarOpen(false);
      }
    }, [adminID, subscribed, navigate, isNonMobile]);
    
    const addHtml = (e) => {
        e.preventDefault();
        if(temp.name !== "" && temp.cost !== ""){
            const newItem = {
                id: Date.now().toString(),
                name: temp.name,
                cost: temp.cost
            };
            
            setPriceList(prevState => ({
                ...prevState,
                addItem: [...(prevState.addItem || []), newItem]
            }));
            
            setTemp({name: "", cost: ""});
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please enter both item name and cost',
                confirmButtonColor: "#60c088",
            });
        }
    };

    const removeItem = (itemToRemove) => {
        if (!itemToRemove || !priceList.addItem) return;
        
        setPriceList(prevState => ({
            ...prevState,
            addItem: prevState.addItem.filter(item => item.id !== itemToRemove.id)
        }));
    };

    const handleSubmit = () => {
        if (!adminID) {
            Swal.fire({
                icon: 'error',
                title: 'Authentication Error',
                text: 'Please sign in again',
                confirmButtonColor: "#60c088",
            });
            navigate("/signin");
            return;
        }
        
        setLoading(true);
        dispatch(savePriceList({...priceList, adminID}))
            .then(() => {
            setLoading(false);
            Swal.fire({
              icon: 'success',
              title: 'Saved',
                    confirmButtonColor: "#60c088",
                });
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to save price list',
                    confirmButtonColor: "#A7B778",
                });
            });
    };

    useEffect(() => {
        if (adminID) {
            dispatch(fetchPriceList({adminID}));
        }
    }, [adminID, dispatch]);

    useEffect(() => {
        if (fetchedPriceList && Object.keys(fetchedPriceList).length > 0) {
            const itemsWithIds = fetchedPriceList.addItem?.map(item => ({
                ...item,
                id: item.id || `existing-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
            })) || [];
            
            setPriceList({
                ...defaultPriceList,
                ...fetchedPriceList,
                addItem: itemsWithIds
            });
        }
    }, [fetchedPriceList]);

    const inputStyle = "bg-gray-200 rounded px-[2px] xxl:p-2 w-11/12 outline-none pl-4 xxl:pl-6 z-20 border border-gray-300 focus:border-lightgreen focus:ring-1 focus:ring-lightgreen";

    const handleItemRemove = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (window.innerWidth < 768) {
            Swal.fire({
                title: 'Remove Item',
                text: `Remove ${item.name} from your list?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#60c088',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, remove it',
                cancelButtonText: 'Cancel'
            }).then((result) => {
                if (result.isConfirmed) {
                    removeItem(item);
                }
            });
        } else {
            removeItem(item);
        }
    };

    return (
    <div className='w-full h-full'>
        <HeaderScaff/>
            <div className={`w-full flex ${!isNonMobile && !sidebarOpen ? "flex-col" : ""} h-auto p-2 sm:p-6`}>
                <div className={`${sidebarOpen ? (isNonMobile ? "basis-1/5" : "flex justify-center w-full") : "hidden"} w-full h-full`}>
        <Sidebar setSidebarOpen={setSidebarOpen} needed={needed} isNonMobile={isNonMobile}/>
      </div>

                <div 
                    onClick={() => setSidebarOpen(true)} 
                    className={`${sidebarOpen ? (isNonMobile ? "hidden" : "hidden") : (isNonMobile ? "flex w-12 mt-4" : "flex border-2 border-x-0 bg-gray-100/50 mt-2 -mb-1 w-full items-center justify-center")} h-fit`}
                >
                    <div className={`${sidebarOpen ? (isNonMobile ? "" : "") : (isNonMobile ? "" : "hidden")}`}>
            <IconButton onClick={() => setSidebarOpen(true)}>
            <ArrowForwardIosIcon/>
            </IconButton>
        </div>
                    <div className={`${sidebarOpen ? (isNonMobile ? "hidden" : "hidden") : (isNonMobile ? "hidden" : "flex")}`}>
            <p className='text-gray-500 text-xs py-[2px]'>Sidebar</p>
        </div>
      </div>

                <div className={`${sidebarOpen ? (isNonMobile ? "basis-4/5 flex flex-col ml-4 md:pt-4" : "hidden") : "w-full flex flex-col pl-3 pt-3"}`}>
                    <div className="mb-4 bg-white p-4 rounded-lg shadow-sm">
                        <h1 className='text-xl xxl:text-2xl font-semibold text-gray-700 mb-2'>Price List Management</h1>
                        <p className='text-sm xxl:text-base text-gray-500'>Update your pricing information for quotes and invoices</p>
                    </div>
                    
                    <div className='flex flex-col lg:flex-row w-full gap-6'>
                        <div className='basis-1 lg:basis-1/2 flex flex-col w-full bg-white p-4 rounded-lg shadow-sm'>
                            <h2 className='text-lg xxl:text-xl font-semibold mb-4 text-gray-700'>Basic Pricing</h2>
                            <p className='text-sm xxl:text-base mb-4 text-gray-600'>Enter your costs per item below or use our default values.</p>
                            
                            <div className='flex flex-col w-full space-y-3'>
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Linear Meterage cost</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, linearMerterageCost: escapeHtml(e.target.value)})} 
                                            value={priceList.linearMerterageCost || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Saddle Cost</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, saddleCost: escapeHtml(e.target.value)})} 
                                            value={priceList.saddleCost || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Throw-in Cost</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, throwinCost: escapeHtml(e.target.value)})} 
                                            value={priceList.throwinCost || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Hop-Up Cost</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, hopUpCost: escapeHtml(e.target.value)})} 
                                            value={priceList.hopUpCost || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Hakki/Layher stairs per lift</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, hakkiLayher: escapeHtml(e.target.value)})} 
                                            value={priceList.hakkiLayher || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <h3 className='text-md xxl:text-lg font-semibold mt-2 mb-2 text-gray-700'>Temporary Roofs</h3>
                                
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Temporary Roof per m²</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, temporaryRoof: escapeHtml(e.target.value)})} 
                                            value={priceList.temporaryRoof || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Monoflex Per m²</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, monoflex: escapeHtml(e.target.value)})} 
                                            value={priceList.monoflex || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                    </div>
                </div>
            
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Shrinkwrap per m²</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, shrinkwrap: escapeHtml(e.target.value)})} 
                                            value={priceList.shrinkwrap || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                                    </div>
                            </div>
                            </div>
                        </div>
                    
                        <div className='basis-1 lg:basis-1/2 flex flex-col w-full bg-white p-4 rounded-lg shadow-sm'>
                            <h2 className='text-lg xxl:text-xl font-semibold mb-4 text-gray-700'>Towers & Additional Items</h2>
                            
                            <div className='flex flex-col w-full space-y-4'>
                                <div className='grid grid-cols-1 sm:grid-cols-4 gap-3'>
                                    <div className='sm:col-span-3'>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Cost for 5 foot/1.8 mtr tower</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle} 
                                                onChange={(e) => setPriceList({...priceList, fivebyonepointeightTower: escapeHtml(e.target.value)})} 
                                                value={priceList.fivebyonepointeightTower || ''} 
                                                type="number" 
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className='sm:col-span-1'>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Cost per lift</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle} 
                                                onChange={(e) => setPriceList({...priceList, fivebyonepointeightTowerCostPerLift: escapeHtml(e.target.value)})} 
                                                value={priceList.fivebyonepointeightTowerCostPerLift || ''} 
                                                type="number" 
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='grid grid-cols-1 sm:grid-cols-4 gap-3'>
                                    <div className='sm:col-span-3'>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Cost for 8 foot/2.4 mtr tower</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle} 
                                                onChange={(e) => setPriceList({...priceList, eightbytwopointfourTower: escapeHtml(e.target.value)})} 
                                                value={priceList.eightbytwopointfourTower || ''} 
                                                type="number" 
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className='sm:col-span-1'>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Cost per lift</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle} 
                                                onChange={(e) => setPriceList({...priceList, eightbytwopointfourTowerCostPerLift: escapeHtml(e.target.value)})} 
                                                value={priceList.eightbytwopointfourTowerCostPerLift || ''} 
                                                type="number" 
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='grid grid-cols-1 sm:grid-cols-4 gap-3'>
                                    <div className='sm:col-span-3'>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Cost for 10 foot/3.0 mtr tower</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle} 
                                                onChange={(e) => setPriceList({...priceList, tenbythreeTower: escapeHtml(e.target.value)})} 
                                                value={priceList.tenbythreeTower || ''} 
                                                type="number" 
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                                        </div>
                            </div>
                                    <div className='sm:col-span-1'>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Cost per lift</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle} 
                                                onChange={(e) => setPriceList({...priceList, tenbythreeTowerCostPerLift: escapeHtml(e.target.value)})} 
                                                value={priceList.tenbythreeTowerCostPerLift || ''} 
                                                type="number" 
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                            </div>
                        </div>
                            </div>
                                
                                <div className='grid grid-cols-1 sm:grid-cols-4 gap-3'>
                                    <div className='sm:col-span-3'>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Cost for 13 foot/4.0 mtr tower</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle} 
                                                onChange={(e) => setPriceList({...priceList, thirteenbyfourTower: escapeHtml(e.target.value)})} 
                                                value={priceList.thirteenbyfourTower || ''} 
                                                type="number" 
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                            </div>
                        </div>
                                    <div className='sm:col-span-1'>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Cost per lift</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle} 
                                                onChange={(e) => setPriceList({...priceList, thirteenbyfourTowerCostPerLift: escapeHtml(e.target.value)})} 
                                                value={priceList.thirteenbyfourTowerCostPerLift || ''} 
                                                type="number" 
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                            </div>
                            </div>
                        </div>
                                
                                <h3 className='text-md xxl:text-lg font-semibold mt-2 mb-2 text-gray-700'>Other Costs</h3>
                                
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Scaffolding Inspections per visit</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, scaffoldingInspectionPerVisit: escapeHtml(e.target.value)})} 
                                            value={priceList.scaffoldingInspectionPerVisit || ''} 
                                            type="number" 
                                            min="0" 
                                            step="0.01"
                                            required
                                        />
                                    </div>
                            </div>
                                
                                <div className="form-group">
                                    <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Overhire percentage</label>
                                    <p className='text-xs text-gray-500 mb-1'>For example, enter 10% for a 4-week hire costing £1000.00, your overhire will be £100.00 per week after 4 weeks</p>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">%</span>
                                        <input 
                                            className={inputStyle} 
                                            onChange={(e) => setPriceList({...priceList, overhirePercentage: escapeHtml(e.target.value)})} 
                                            value={priceList.overhirePercentage || ''} 
                                            type="number" 
                                            min="0" 
                                            max="100"
                                            required
                                        />
                            </div>
                        </div>
                                
                                <h3 className='text-md xxl:text-lg font-semibold mt-2 mb-2 text-gray-700'>Custom Items</h3>
                                
                                <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
                                    <div>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Item Name</label>
                                        <input 
                                            className="bg-gray-200 rounded px-2 xxl:p-2 w-full outline-none border border-gray-300 focus:border-lightgreen focus:ring-1 focus:ring-lightgreen" 
                                            type="text" 
                                            onChange={(e) => setTemp({...temp, name: escapeHtml(e.target.value)})} 
                                            value={temp.name} 
                                            placeholder="Enter item name"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className='block text-sm xxl:text-base font-medium text-gray-700 mb-1'>Item Cost</label>
                                        <div className="relative">
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-500">£</span>
                                            <input 
                                                className={inputStyle}
                                                type="number" 
                                                onChange={(e) => setTemp({...temp, cost: escapeHtml(e.target.value)})} 
                                                value={temp.cost} 
                                                placeholder="0.00"
                                                min="0" 
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <button 
                                    onClick={addHtml} 
                                    className='self-start w-32 h-10 text-white font-medium cursor-pointer rounded-md bg-lightgreen hover:bg-darkgreen transition-colors duration-200 flex items-center justify-center'
                                >
                                    Add Item
                                </button>
                                
                                <div className='mt-2'>
                                    {priceList.addItem && priceList.addItem.length > 0 ? (
                                        <div className="space-y-2">
                                            {priceList.addItem.map((item) => (
                                                <div 
                                                    key={item.id || `item-${item.name}`} 
                                                    className='flex flex-row p-3 bg-gray-100 rounded border border-gray-200 w-full items-center justify-between'
                                                >
                                                    <div className='flex pr-3 mr-1 flex-row items-center w-full justify-between'>
                                                        <span className='font-medium text-sm xxl:text-base text-gray-700'>{item.name}</span>
                                                        <span className='font-medium text-sm xxl:text-base text-gray-700'>£{item.cost}</span>
                                                    </div>
                                                    <button 
                                                        onClick={(e) => handleItemRemove(e, item)} 
                                                        className='ml-2 w-8 h-8 rounded-full hover:bg-gray-300 flex items-center justify-center transition-colors duration-200 touch-manipulation'
                                                        aria-label="Remove item"
                                                    >
                                                        <span className="text-gray-500 font-medium">×</span>
                                                    </button>
                                                </div>
                                            ))}
                        </div>
                                    ) : (
                                        <p className="text-gray-500 text-sm italic">No custom items added yet</p>
                                    )}
                                </div>
                                
                                <div className='flex justify-end mt-4'>
                                    {loading ? (
                                        <div className='flex items-center bg-gray-100 rounded-md px-4 py-2'>
                                            <CircularProgress size={24} className='mr-2' color="success"/>
                                            <p className='text-gray-700'>Saving changes...</p>
                                        </div>
                                    ) : (
                                        <button 
                                            className='w-32 h-10 text-white font-medium cursor-pointer rounded-md bg-lightgreen hover:bg-darkgreen transition-colors duration-200 flex items-center justify-center' 
                                            onClick={handleSubmit}
                                        >
                                            Save Changes
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    </div>
    </div>
  )
}

export default PriceList